import { createStore, applyMiddleware, compose } from "redux";
import createSagaMiddleware from "redux-saga";

import { rootSaga } from "saga-slice";
import authModule from "./sagas/authSlice";
import appReducer from "./reducers";
import productSlice from "./sagas/productSlice";
import persistReducer from "redux-persist/es/persistReducer";
import storage from 'redux-persist/lib/storage';
import persistStore from "redux-persist/es/persistStore";
import saleModule from "./sagas/saleSlice";
import stockSlice from "./sagas/stockSlice";
import supplierSlice from "./sagas/supplierSlice";
import refundSlice from "./sagas/refundSlice";
import clientSlice from "./sagas/clientSlice";
import invoiceSlice from "./sagas/invoiceSlice";
import devisSlice from "./sagas/devisSlice";
import supplierProductSlice from "./sagas/supplierProductSlice";
import purchaseModule from "./sagas/purchaseSlice";
import deliverySlice from "./sagas/deliveryNoteSlice";
import inventorySlice from "./sagas/inventorySlice";
import receiptNoteModule from "./sagas/receiptNoteSlice";
import invoiceSupplierSlice from "./sagas/invoiceSupplierSlice";
import categorySlice from "./sagas/categorySlice";
import unitesSlice, { unitesActions } from "./sagas/unitesSlice";
import commandeSlice from "./sagas/commandeSlice";
import entrepotSlice from "./sagas/entrepotSlice";
import transporteurSlice from "./sagas/transporteurSlice";
import reglementModule from "./sagas/reglementSlice";
import lotSlice from "./sagas/lotSlice";
import mouvementStockSlice from "./sagas/mouvementStockSlice";
import customerReturnSlice from "./sagas/customerReturnSlice";
import comptabiliteSlice from "./sagas/comptabiliteSlice";
import soldeSlice from "./sagas/soldeSlice";
import reglementFournisseurModule from "./sagas/reglementFournisseurSlice";
import retourFournisseurSlice from "./sagas/retourFournisseurSlice";
import expenseSlice from "./sagas/expenseSlice";
import commercialSlice from "./sagas/commercialSlice";
import commissionPlanSlice from "./sagas/commissionPlanSlice";
import userSlice from "./sagas/userSlice";
import dalaSlice from "./sagas/dalaSlice";
import companySlice from "./sagas/companySlice";

const sagaMiddleware = createSagaMiddleware();
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth'] // Only persist auth state
};

const modules = [authModule, productSlice, saleModule, stockSlice, 
  clientSlice,invoiceSlice,devisSlice,supplierProductSlice,
  purchaseModule,deliverySlice, stockSlice, refundSlice, inventorySlice, 
  supplierSlice, receiptNoteModule, invoiceSupplierSlice, categorySlice, unitesSlice, commandeSlice, entrepotSlice, 
  transporteurSlice, reglementModule, lotSlice, mouvementStockSlice, customerReturnSlice, 
  comptabiliteSlice, soldeSlice, reglementFournisseurModule, retourFournisseurSlice, 
  expenseSlice, commercialSlice, commissionPlanSlice, userSlice, dalaSlice, companySlice];
const persistedReducer = persistReducer(persistConfig, appReducer);

const store = createStore(
  persistedReducer,
  composeEnhancers(applyMiddleware(sagaMiddleware))
);
const persistor = persistStore(store);

sagaMiddleware.run(rootSaga(modules));

export { store, persistor };
